import { useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';
import { routes } from './routes';
import { useTheme } from './useTheme';

export function App() {
  useTheme();
  const [router] = useState(() => createBrowserRouter(routes));
  return <RouterProvider router={router} />;
}
